import { constants } from '@saucelabs/sl-module-cloudtype';

import * as utils from './utils';
import rdcOperations from './rdc/operations';
import vdcOperations, { openSourceOperations as vdcOpenSourceOperations } from './vdc/operations';

export const getV2Operations = ({ cloudType, isOpenSource }) => {
  const isRDBuilds = cloudType === constants.CLOUD_REAL;
  if (isRDBuilds) {
    return rdcOperations;
  }

  return isOpenSource ? vdcOpenSourceOperations : vdcOperations;
};

export const getBuilds = (payload) => async (dispatch) => {
  const meta = { skipErrorPage: true };
  const params = utils.buildsV2QueryParams(payload);
  return dispatch(getV2Operations(payload).initialize(params, meta));
};
